<template>
  <div class="mainitem" @click="goodclick('projectdetail')">
    <a href="javascript:void(0);">
      <div class="mainitemimg">
        <img :src="project.thumbnail" alt />
      </div>
      <!-- <div class="lll"></div> -->
      <div class="mainitemtitle">{{project.title}}</div>
      <!-- <div class="mainitemtop">
        <div class="mainiteminfoone">
          <b>{{dateone}}</b>
        </div>
        <div class="mainiteminfotwo">{{datetwo}}</div>
      </div>-->
    </a>
  </div>
</template>

<script>
export default {
  name: "project",
  props: {
    project: {
      type: Object,
    }
  },
  data() {
    return {
    }
  },
  methods: {
    goodclick(name) {
      this.$router.push({ name, params: { id: this.project.id } })
      // location.href = `/#/${name}/${this.project.id}`
      window.first = true
      // this.$router.push({ name })
    }
  },
  computed: {
    dateone() {
      return this.$formatDate("dd", this.project.created_at || "")
    },
    datetwo() {
      return this.$formatDate("yyyy.MM", this.project.created_at || "")
    }
  }
}
</script>

<style scoped>
.mainitem {
  width: 100%;
  max-width: 22%;
  position: relative;
  margin: 0 1.5%;
  overflow: hidden;
  /* padding-bottom: 0.6rem; */
}
.lll {
  height: 0.6rem;
}
.mainitemimg {
  width: 100%;
}
.mainitemimg img {
  width: 100%;
  transition: all 0.6s;
}
.mainitemtitle {
  /* position: absolute; */
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.2rem;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0.5rem;
  margin-top: 0.14rem;
  /* bottom: 18px; */
}
.mainitem:hover .mainitemtitle {
  /* color: #fff; */
  /* background-color: #ff6900; */
}

.mainitem:hover .mainitemimg img {
  transform: scale(1.1);
}
.mainitemtop {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.7rem;
  height: 0.7rem;
  text-align: center;
  background-color: #ff6900;
  color: #fff;
  padding-top: 0.1rem;
}
.mainiteminfoone {
  font-size: 0.3rem;
  line-height: 0.3rem;
}
.mainiteminfotwo {
  font-size: 0.1rem;
}

@media (max-width: 992px) {
  .mainitem {
    width: 100%;
    max-width: 46%;
    margin: 40px 0;
  }
  .mainitemtop {
    position: absolute;
    top: 0;
    left: 0;
    width: 140px;
    height: 140px;
    text-align: center;
    background-color: #ff6900;
    color: #fff;
    padding-top: 0.1rem;
  }

  .mainiteminfoone {
    font-size: 56px;
    line-height: 70px;
  }
  .mainiteminfotwo {
    font-size: 30px;
  }
  .mainitemtitle {
    font-size: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/short-project-item.vue